import config from "../../config";

const createRefund = async (hotelId, bookingId) => {
  let token = sessionStorage.getItem("token");

  try {
    let response = await fetch(config.beAlphaEndpoint + "create-refund", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        hotel_id: hotelId,
        booking_id: bookingId,
      }),
    });

    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    return { status: 0, message: "Something went wrong" };
  }
};

export default createRefund;
